import Vue from 'vue'
import RestrictiveComponent from './../Components/restrictiveComponent.vue'
import RestrictiveIconComponent from './../Components/restrictiveIconComponent.vue'
import { demandPlan } from 'Services/appPlanList'
import { mapState } from 'vuex';


// Defina a diretiva global
 const RestrictiveDirective = {

  inserted(el, binding) {
    type OptionsType = 'icon' | 'replace' | 'button-replace' | 'link' | 'button'
    const RESTRICTIVE_OPTIONS: OptionsType = binding.value.type
    const text = binding.value.feature
    const companyName = binding.value.companyName

    const isFreePlan = binding.value.isFreePlan

    let component;
    if(isFreePlan) {
      switch (RESTRICTIVE_OPTIONS) {
      case 'icon':
        component = new Vue({
          render: (h) => h(RestrictiveIconComponent, { props: { text } }),
        }).$mount()

        el.appendChild(component.$el, el)
        break;
      case 'replace':
        component = new Vue({
          render: (h) => h(RestrictiveComponent, { props: { text, companyName } }),
        }).$mount()

        el.parentNode.replaceChild(component.$el, el)
        break;
      case 'button-replace':
        el.setAttribute('disabled', 'disabled')

        component = new Vue({
          render: (h) => h(RestrictiveComponent, { props: { text, companyName } }),
        }).$mount()

        el.parentNode.appendChild(component.$el, el)
        break;
      case 'link':
        component = new Vue({
          render: (h) => h(RestrictiveIconComponent, { props: { text } }),
        }).$mount()

        el.href = '#'

        el.appendChild(component.$el, el)
        break;
      case 'button':
        el.classList.add("tooltip-multiline")
        el.classList.add("tooltip-bottom-right")
        el.setAttribute('disabled', 'disabled')
        el.setAttribute('data-tooltip', 'Assine um plano CoteiBem para desbloquear este recurso.')
        el.href = '#'

        break;
      default:
        break;
      }
    }
  },
}

export default RestrictiveDirective